import { useEffect, useState } from 'react'
import ButtonComponent from '../shared/button/button.component'
import { DialogHeaders, buttonLabels, ToasterTexts } from '../shared/constants'
import { Dialog, DialogActions, DialogContent, DialogTitle, FormHelperText, Grid, TextField, Tooltip } from "@mui/material";
import { MediaModel, TemplateModel } from '../../models/templates.models';
import setToast from '../../helpers/toaster.helper';
import { ToasterType } from '../shared/toaster/toaster.model';
import { TemplateService } from '../../services/TemplateService';
import { validateForm } from '../shared/form-validation';
import MessageComposer from '../conversations/message-composer';
import { Autocomplete } from "@mui/material";
import { BackMobileIcon, CancelIcon } from '../../icon';
import { useSelector } from 'react-redux';
import * as selector from "../../selectors/selectors"


let type = [{ Name: "Private", Value: "Private" }, { Name: "Phone Line", Value: "PhoneNumberLevel" }, { Name: "Organization", Value: "Public" }];

interface IDispatchProps { }

interface Props extends IDispatchProps {
    CloseTemplate: (confirm: boolean) => void;
    Template?: TemplateModel;
    Show: boolean;
    IsDuplicate?: boolean;
}

const EditTemplate = (props: Props) => {

    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const IsDarkMode: boolean = useSelector(selector.isDarkMode)
    const [dailogTitle, setDailogtitle] = useState<string>("")
    const [isUploading, setIsUploading] = useState<boolean>(false)
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [isEdit, setIsEdit] = useState<boolean>(!!props.Template?.ID)

    const [userinput, setUserinput] = useState<TemplateModel>({
        ...(props.Template || {
            ID: "",
            Title: "",
            Message: "",
            Media: props?.Template?.Media || [],
            UpdatedDateTime: "",
            CreatedByID: "",
            IsPrivate: true,
            IsPhoneNumberLevel: false

        })
    })
    const [errors, setErrors] = useState<{
        Title: string;
        Message: string;
        Type: string;
        [key: string]: any;
    }>({
        Title: "",
        Message: "",
        Type: ""
    })

    useEffect(() => {
        setDailogtitle(props.IsDuplicate ? DialogHeaders.DUPLICATE_TEMPLATE : !!props.Template?.ID ? DialogHeaders.EDIT_TEMPLATE : DialogHeaders.ADD_TEMPLATE)
    }, [])

    const handleChange = (e: any) => {
        validateForm({ [e.target.name]: e.target.value }, (Errors) => {
            setUserinput({ ...userinput, Title: e.target.value })
            setErrors({ ...errors, ...Errors })
        })
    };

    const handleMessageChanges = (data: { body: string, media: MediaModel[], bodyLength: number }) => {
        if (data.body?.length < 1 && data.media?.length < 1 && (data.body !== userinput.Message || data.media?.length !== userinput?.Media?.length)) {
            setUserinput({ ...userinput, Message: data.body, Media: data.media })
            setErrors({ ...errors, Message: "Message cannot be blank" })
        } else {
            setUserinput({ ...userinput, Message: data.body, Media: data?.media })
            setErrors({ ...errors, Message: "" })
        }
    }

    const formSubmit = (event: any) => {
        event.preventDefault();
        const customValidator = !!userinput.Media?.length ?
            validateForm({ Title: userinput.Title, Type: userinput.IsPrivate }, (Errors) => {
                setErrors({ ...errors, ...Errors })
            }) || validateForm({ Title: userinput.Title, Type: userinput.IsPhoneNumberLevel }, (Errors) => {
                setErrors({ ...errors, ...Errors })
            })
            : validateForm({ Title: userinput.Title, Type: userinput.IsPrivate, Message: userinput.Message }, (Errors) => {
                setErrors({ ...errors, ...Errors })
            }) || validateForm({ Title: userinput.Title, Type: userinput.IsPhoneNumberLevel, Message: userinput.Message }, (Errors) => {
                setErrors({ ...errors, ...Errors })
            })

        if (customValidator) {
            setIsLoading(true)
            let obj: any = {
                "id": userinput.ID || undefined,
                "title": userinput.Title,
                "message": userinput.Message,
                "createdById": userinput.CreatedByID,
                "media": !!userinput.Media?.length ? userinput.Media : undefined,
                "isPrivate": userinput.IsPhoneNumberLevel ? false : userinput.IsPrivate,
                "isPhoneNumberLevel": userinput.IsPrivate ? false : userinput.IsPhoneNumberLevel
            }
            let Name = userinput.Title;
            if (!!userinput.ID) {
                TemplateService.updateTemplates(obj)
                    .then(() => {
                        setIsLoading(false)
                        setToast(ToasterTexts.TEMPLATE_UPDATE_SUCCESS.replace('<Name>', Name), ToasterType.SUCCESS)
                        props.CloseTemplate(true)
                    })
                    .catch((err) => {
                        setToast(err.response.data.message, ToasterType.DANGER)
                        setIsLoading(false)
                    });
            } else {
                TemplateService.createTemplate(obj).then((res) => {
                    setIsLoading(false)
                    setToast(props.IsDuplicate ? ToasterTexts.TEMPLATE_DUPLICATE_SUCCESS.replace('<Name>', Name) : ToasterTexts.TEMPLATE_ADD_SUCCESS.replace('<Name>', Name), ToasterType.SUCCESS)
                    props.CloseTemplate(true)
                })
                    .catch((err) => {
                        setToast(err.response.data.message, ToasterType.DANGER)
                        setIsLoading(false)
                    });
            }
            props.CloseTemplate(true)
        }
    }
    return (
        <div>
            {IsMobileDevice ?
                <div className={` o-x-hidden w-fill h-v-100 ${IsDarkMode ? "bg-color-sidebar-bg" : "paper-background"}`}>
                    <Grid item xs={12}>
                        <div className='box-shadow-display-background-shadow d-flex p-2'>
                            {IsMobileDevice && <span><BackMobileIcon className={"c-pointer pr-2"} onClick={() => props.CloseTemplate(false)} /></span>}
                            <span className={`h1 my-auto color-add-details-title mr-auto`}>
                                {dailogTitle}
                            </span>
                        </div>
                    </Grid>
                    <Grid container direction="column" spacing={3} className="mt-2">
                        <Grid item xs={12}>
                            <TextField
                                autoFocus
                                placeholder="Title "
                                label="Title"
                                variant="outlined"
                                size="small"
                                name="Title"
                                required
                                fullWidth
                                value={userinput.Title}
                                className="w-p-95 ml-1 mr-1"
                                onChange={(e) => handleChange(e)}
                            />
                            <FormHelperText className="h5 color-primary-danger t-align-right mr-1">
                                {errors.Title}
                            </FormHelperText>
                        </Grid>
                        <Grid item xs={12}>
                            <Autocomplete
                                size="small"
                                className='w-p-95 ml-1 m-1'
                                classes={{ input: 'h4-regular color-text-field-font', paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow' }}
                                options={type}
                                getOptionLabel={(option) => option?.Name}
                                disableClearable
                                onChange={(event: any, value: any | null) => {
                                    if (value) {
                                        setUserinput({ ...userinput, IsPrivate: value.Value === "Private", IsPhoneNumberLevel: value.Value === "PhoneNumberLevel" })
                                        setErrors({ ...errors, Type: "" })
                                    }
                                }}
                                value={type.find(x => userinput.IsPrivate ? x.Value === "Private" : userinput.IsPhoneNumberLevel ? x.Value === "PhoneNumberLevel" : x.Value === "Public")}
                                renderOption={(defaultprops, option: any, { selected }) => (
                                    <li {...defaultprops} className={`${defaultprops.className} c-pointer h4-regular color-menu-list-font-color p-2 d-flex justify-between ${selected ? 'Mui-focused' : ''}`} >
                                        {option?.Name}
                                    </li>
                                )}
                                disabled={isEdit}
                                renderInput={(params) =>
                                    <TextField
                                        {...params}
                                        label="Shared"
                                        name="Type"
                                        placeholder="Shared"
                                        required
                                        variant="outlined"
                                    />
                                } />
                            <FormHelperText className="h5 color-primary-danger t-align-right mr-1">
                                {errors.Type}
                            </FormHelperText>
                        </Grid>
                        <Grid item xs={12} className="m-1">
                            <MessageComposer
                                HandleClose={() => props.CloseTemplate(false)}
                                Message={userinput.Message}
                                HandleChange={handleMessageChanges}
                                IsAddTemplate={true}
                                Limit={1}
                                IsNewMessage={true}
                                TemplateErrorMessage={!userinput.Media?.length && errors.Message}
                                IsCamPaign={false}
                                MultiMedia={userinput.Media}
                            />
                        </Grid>
                    </Grid>
                    <div className="d-flex my-2 px-2 mt-auto">
                        <ButtonComponent OnClick={() => props.CloseTemplate(false)} ButtonLabel={buttonLabels.CANCEL} ClassName={"ml-auto"} Variant={"secondary-btn-small"} />
                        <ButtonComponent OnClick={formSubmit} Type={"submit"} ButtonLabel={buttonLabels.SAVE} ClassName={"px-4 ml-2 mr-1"} Variant={isUploading ? "disabled-btn-small" : "primary-btn-small"} Loading={isLoading} />
                    </div>
                </div> :
                <Dialog
                    fullWidth
                    maxWidth="sm"
                    // onClose={() => props.CloseTemplate(false)}
                    aria-labelledby="responsive-dialog-title"
                    open={props.Show}
                    BackdropProps={{
                        style: { backgroundColor: "transparent" },
                    }}
                    className={`${IsDarkMode ? "" : " dialogue-shadow"}`}
                    disableEscapeKeyDown
                >
                    <DialogTitle className={`p-2 ${IsDarkMode ? "bg-color-sidebar-bg" : " bg-color-primary-background"}`} >
                        <div className={`h2-regular ${IsDarkMode ? "" : "color-display-titl"}e d-flex`} id="customized-dialog-title">
                            {dailogTitle}
                            <Tooltip title="Close" placement="bottom">
                                <span className="ml-auto mr-1">
                                    <CancelIcon className={"c-pointer"} onClick={() => props.CloseTemplate(false)} />
                                </span>
                            </Tooltip>
                        </div>
                    </DialogTitle>
                    <div className={"bb-primary-background-pink-4 mx-2"}></div>
                    <DialogContent className={`o-hidden pt-1 p-2 ${IsDarkMode ? "bg-color-sidebar-bg" : " bg-color-primary-background"}`}>
                        <Grid container direction="column" className="">
                            <Grid item xs={12}>
                                <TextField
                                    autoFocus
                                    placeholder="Title "
                                    label="Title"
                                    variant="outlined"
                                    size="small"
                                    name="Title"
                                    required
                                    fullWidth
                                    value={userinput.Title}
                                    onChange={(e) => handleChange(e)}
                                />
                                <FormHelperText className="h5 color-primary-danger t-align-right mr-1">
                                    {errors.Title}
                                </FormHelperText>
                            </Grid>
                            <Grid item xs={12} className='py-2'>
                                <Autocomplete
                                    size="small"
                                    classes={{ input: 'h4-regular color-text-field-font', paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow' }}
                                    options={type}
                                    getOptionLabel={(option) => option?.Name}
                                    disableClearable
                                    onChange={(event: any, value: any | null) => {
                                        if (value) {
                                            setUserinput({ ...userinput, IsPrivate: value.Value === "Private", IsPhoneNumberLevel: value.Value === "PhoneNumberLevel" })
                                            setErrors({ ...errors, Type: "" })
                                        }
                                    }}
                                    value={type.find(x => userinput.IsPrivate ? x.Value === "Private" : userinput.IsPhoneNumberLevel ? x.Value === "PhoneNumberLevel" : x.Value === "Public")}
                                    renderOption={(defaultprops, option: any, { selected }) => (
                                        <li {...defaultprops} className={`${defaultprops.className} c-pointer h4-regular color-menu-list-font-color p-2 d-flex justify-between ${selected ? 'Mui-focused' : ''}`} >
                                            {option?.Name}
                                        </li>
                                    )}
                                    disabled={isEdit}
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            label="Shared"
                                            name="Type"
                                            placeholder="Shared"
                                            required
                                            variant="outlined"
                                        />
                                    }
                                />
                                <FormHelperText className="h5 color-primary-danger t-align-right mr-1">
                                    {errors.Type}
                                </FormHelperText>
                            </Grid>
                            <Grid item xs={12} className="">
                                <MessageComposer
                                    HandleClose={() => props.CloseTemplate(false)}
                                    Message={userinput.Message}
                                    HandleChange={handleMessageChanges}
                                    IsAddTemplate={true}
                                    Limit={1}
                                    IsNewMessage={true}
                                    TemplateErrorMessage={!userinput.Media?.length && errors.Message}
                                    IsCamPaign={false}
                                    MultiMedia={userinput.Media}
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions className={`pb-2 ${IsDarkMode ? "bg-color-sidebar-bg" : " bg-color-primary-background"}`}>
                        <ButtonComponent OnClick={() => props.CloseTemplate(false)} ButtonLabel={buttonLabels.CANCEL} ClassName={"ml-auto"} Variant={"secondary-btn-small"} />
                        <ButtonComponent OnClick={formSubmit} Type={"submit"} ButtonLabel={buttonLabels.SAVE} ClassName={"px-4 mr-1"} Variant={isUploading ? "disabled-btn-small" : "primary-btn-small"} Loading={isLoading} />
                    </DialogActions>
                </Dialog>
            }
        </div>
    )
}
export default EditTemplate;